import { Button, Layout } from 'antd';
import type React from 'react';

import { IconAuthLogo } from 'src/components/icons/icon-auth-logo/icon-auth-logo';

import './auth-layout.css';
import { IconLink } from 'src/components/icons/icon-link/icon-link';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <Layout className="min-h-screen flex flex-row min-w-[1280px]">
      <div className="auth-layout-wrapper w-1/2 text-gray-1 relative overflow-hidden">
        <div className="auth-layout-bg bg-cover bg-center bg-no-repeat absolute-fill" />
        <div className="auth-layout-lines bg-cover bg-center bg-no-repeat absolute-fill" />
        <div className="auth-layout-elements bg-cover bg-center bg-no-repeat absolute-fill" />

        <div className="auth-layout-shape absolute absolute-center-x top-[40%] text-center w-[527px] space-y-24">
          <div className="text-[46px]/[54px] font-bold">Personalization Boost for Your Casino</div>

          <Button
            target="_blank"
            href="https://www.zingbrain.ai"
            className="inline-flex items-center gap-x-8 text-gray-1 bg-transparent border-gray-5 hover:border-gray-1"
          >
            <IconLink />
            Learn More
          </Button>
        </div>
      </div>

      <div className="w-1/2 p-24">
        <div className="mt-78 mb-26 flex items-center justify-center gap-x-10">
          <img src="/assets/public/images/zing-logo.webp" alt="logo" width={52} height={50} />
          <IconAuthLogo />
        </div>

        <div className="mx-auto max-w-[421px]">{children}</div>
      </div>
    </Layout>
  );
};
